var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryEmptySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 174,
    viewBox: "0 0 212 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 212,
    height: 172,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.536 57.9004C178.815 57.9004 181.472 60.5956 181.472 63.9204C181.472 67.2451 178.815 69.9404 175.536 69.9404H141.616C144.895 69.9404 147.552 72.6356 147.552 75.9604C147.552 79.2851 144.895 81.9804 141.616 81.9804H160.272C163.551 81.9804 166.208 84.6756 166.208 88.0004C166.208 91.3251 163.551 94.0204 160.272 94.0204H151.645C147.511 94.0204 144.16 96.7156 144.16 100.04C144.16 102.257 145.856 104.264 149.248 106.06C152.527 106.06 155.184 108.756 155.184 112.08C155.184 115.405 152.527 118.1 149.248 118.1H78.8644C75.5861 118.1 72.9284 115.405 72.9284 112.08C72.9284 108.756 75.5861 106.06 78.8644 106.06H45.7924C42.5141 106.06 39.8564 103.365 39.8564 100.04C39.8564 96.7156 42.5141 94.0204 45.7924 94.0204H79.7124C82.9908 94.0204 85.6484 91.3251 85.6484 88.0004C85.6484 84.6756 82.9908 81.9804 79.7124 81.9804H58.5124C55.2341 81.9804 52.5764 79.2851 52.5764 75.9604C52.5764 72.6356 55.2341 69.9404 58.5124 69.9404H92.4324C89.1541 69.9404 86.4964 67.2451 86.4964 63.9204C86.4964 60.5956 89.1541 57.9004 92.4324 57.9004H175.536ZM175.536 81.9804C178.815 81.9804 181.472 84.6756 181.472 88.0004C181.472 91.3251 178.815 94.0204 175.536 94.0204C172.258 94.0204 169.6 91.3251 169.6 88.0004C169.6 84.6756 172.258 81.9804 175.536 81.9804Z",
    fill: "#DFE5EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92C85 108.006 97.9945 121 114 121C130.006 121 143 108.006 143 92C143 75.9945 130.006 63 114 63C97.9945 63 85 75.9945 85 92Z",
    fill: "#FFF7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75 86C75 105.869 91.1311 122 111 122C130.869 122 147 105.869 147 86C147 66.1311 130.869 50 111 50C91.1311 50 75 66.1311 75 86Z",
    stroke: "#88C3E1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111 66V86L123 98",
    stroke: "#FB9C0C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.605 68.9956C162.695 66.6982 160.891 64.8778 158.616 63.9587L158.268 63.8183L158.616 63.6778C160.891 62.7587 162.695 60.9384 163.605 58.641L163.744 58.2899L163.883 58.641C164.794 60.9384 166.597 62.7587 168.872 63.6778L169.22 63.8183L168.872 63.9587C166.597 64.8778 164.794 66.6982 163.883 68.9956L163.744 69.3466L163.605 68.9956Z",
    stroke: "#FB9C0C",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryEmptySvg);
export default __webpack_public_path__ + "static/media/HistoryEmptySvg.c6f8985ee075f7ea12c910dac855e57f.svg";
export { ForwardRef as ReactComponent };